import { Graphiql } from "../components/Graphiql";

export const Editor = () => {
  return <Graphiql />;
};
